import React from 'react';
import {object} from 'prop-types';

import classes from './PanelInsert.module.css';

const CompanyPanelInsert = ({node}) => {
    // Formatting Contractor Types
    const contractorTypeFormatted = node.contractorType.join(', ');

    return (
        <dl className={classes.agentInfo}>
            <dt>Name</dt>
            <dd>{node.name}</dd>

            <dt>Address</dt>
            <dd>{node.address}</dd>

            <dt>Contractor Type</dt>
            <dd>{contractorTypeFormatted}</dd>
        </dl>
    );
};

CompanyPanelInsert.defaultProps = {
    node: {}
};

CompanyPanelInsert.propTypes = {
    node: object.isRequired
};

export default CompanyPanelInsert;
